import { render, staticRenderFns } from "./TracesTab.vue?vue&type=template&id=4e8eb468&"
import script from "./TracesTab.vue?vue&type=script&lang=js&"
export * from "./TracesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports